'use client';

import Profile from '@/components/Profile';

const ProfilePage = () => (
  <Profile />
);

export default ProfilePage;
